export default {
  title: 'ארכיון תשלומים נוספים',
  notification: {
    errors: {
      find: {
        title: 'קיימת בעיה בהצגת הנתונים',
        message: 'לא ניתן למצוא תשלומיםם בארכיון אנא נסה שנית',
      },
    },
  },
};
